import axios from 'axios';
import qs from 'qs';
import '@infocert/ui-kit/dist/script.min.js';
import { openBlock, createElementBlock, createElementVNode, toDisplayString, createCommentVNode } from 'vue';

const wsService = {
    service: null,

    close() {
        if (this.service.readyState == WebSocket.OPEN)
            this.service.close();
    },

    async startAPI(transactionId, url) {
        this.service = new WebSocket(url);
        this.service.onopen = (event) => {

            console.log("SOCKET_ONOPEN", event);

            this.startChallengeMsg(transactionId);
        };

    },
    onError(callback) {
        this.service.addEventListener('close', function (event) {
            console.log("SOCKET_CLOSE", event);
            if (event.code !== 1000) {
                callback(event);
            }
        });

    },
    sendMsg(msg) {
        const initMsg = JSON.stringify(msg);
        console.log('init msg:', initMsg);
        if (1 === this.service.readyState)
            this.service.send(initMsg);
        else {
            console.log('Error');
        }
    },
    onAuthenticated(callback, errorCallback) {
            this.service.addEventListener('message', function (event) {
                let data = JSON.parse(event.data);
                if (data.type === 'passwordLessAuthenticationCompleted') {
                    console.log('Authenticated');
                    callback();
                }
                if (data.type === 'passwordLessTransactionExpired') {
                    console.log('Expired');
                    errorCallback({code: 400});
                }
            });

    }
    ,
    getQrCode() {
        return new Promise((resolve) => {


            this.service.addEventListener('message', (event) => {
                console.log("SOCKET_ONMESSAGE", event.data);
                let data = JSON.parse(event.data);

                if (data.type === 'passwordLessChallenge') {
                    const qrcode = 'data:image/png;base64,' + data.challenge;
                    resolve(qrcode);
                }
            });
        })
    },
    startChallengeMsg(passwordLessSessionId) {
        let initMsg = {
            type: "startCheckCloseTransaction",
            passwordLessSessionId: passwordLessSessionId,
            challenge_type: "qrcode",
            app: "SPID",
            reason: "login"
        };

        this.sendMsg(initMsg);
    }
    ,

    sendNewChallenge(passwordLessSessionId) {
        let initMsg = {
            type: "newPasswordlessAuthenticationChallenge",
            passwordLessSessionId: passwordLessSessionId,
            challenge_type: "qrcode",
            app: "SPID",
            reason: "login"
        };
        this.sendMsg(initMsg);
    }
};

const clientAPI = url =>
  axios.create({
    maxRedirects: 1,
    baseURL: url,
    withCredentials: false
  });

var AuthService = {

    qrLogin(user, url) {
        const baseQrCodeURL = window.location.protocol + '//' + window.location.host + url;
        console.log("auth.service qrLogin");
        let config = {
            headers: {
              'InfoCert-Correlation-ID': user.sessionId
            }
        };
        const data = {
            sessionId: user.sessionId,
            authCode: user.authCode
        };
        return clientAPI().post(baseQrCodeURL, qs.stringify(data), config);
    },



};

const data = {
    "it": {
        "label_check_myinfocert":"Hai l'App MyInfoCert?",
        "qr_code": "Inquadra il QR Code con l’App per accedere velocemente.",
        "code_valid_for":"Il codice è valido per ",
        "seconds":" secondi",
        "error":"Servizio QR Code non disponibile, <br>utilizza Nome utente e password",
		"error_age":"Spiacente {user}, ma non hai l'età richiesta da {sp} per accedere al servizio"
	},
    "en": {
        "label_check_myinfocert":"Do you have the MyInfoCert App?",
        "qr_code": "Scan the QR Code with the App for quick access.",
        "code_valid_for":"The code is valid for ",
        "seconds":" seconds",
        "error":"QR Code Service unavailable, <br>use Username and Password",
		"error_age":"Sorry {user}, you do not have the age requested by {sp} to access the service"
	}
};
var messages = {
    messages: data
};

var script = {
  name: 'QrCode',

  props: {
    value: Number,
    samlurl: String,
    refresh: [String, Number],
    locale: String,
    wsurl: String,
    authurl: String

  },

  emits: ["logged", "error"],

  data() {
    return {
      APP_SAML_URL: this.samlurl,
      tempo: this.refresh,
      wsService: wsService,
      translation: messages,
      messages: messages.messages[this.locale],
      errored: false,
      ageErrored: null,
      WSS_URL: this.wsurl,
      AUTH_URL: this.authurl,
      qrcode_img: {
        src: "img/loading.gif",
        width: "32",
        height: "32"
      },
    };
  },

  created(){
    this.messages = this.translation.messages[this.locale];
  },

  unmounted() {
    console.log('unmounted:', this.timeout);
    if (this.timeout !== null) {
      clearInterval(this.timeout);
      this.wsService.close();
    }

  },
  mounted() {
    console.log("QRCode - created()");

    this.transactionId = this.getParam('transactionId');
    this.authCode = this.getParam('authCode');
    console.log("QRCode - transactionId: " + this.transactionId);

    const url = this.WSS_URL;

    this.wsService.startAPI(this.transactionId, url);
    this.wsService.onError((error)=> {
      this.handleWsError(error);
    });
    this.wsService.onAuthenticated(()=> {
      if (this.timeout !== null) {
        clearInterval(this.timeout);

      }
      this.wsService.close();
      setTimeout(() => {
        this.handleLogin();
      }, 1000);
    },  this.handleWsError);

    this.setQrCode();
  },

  methods: {
    clearData(){
      sessionStorage && sessionStorage.clear();
    },
    getParam(name) {
      let urlParams = new URLSearchParams(window.location.search);
      let myParam = urlParams.get(name);
      return myParam;
    },
    handleLogin() {
      console.log("QR Code handleLogin()");

      this.errored = false;
      this.ageErrored = null;


      this.loading = true;
      let user = {

        'sessionId': this.transactionId,
        'authCode': this.authCode
      };

      AuthService.qrLogin(user, this.authurl).then(response => {
        const location = response.headers['location'];

        console.log("AuthService.qrLogin(user) response:" + JSON.stringify(response));
        console.log("AuthService.qrLogin(user) response Location header:" + location);
        let urlParams = new URLSearchParams(window.location.search);
        let state = urlParams.get('state');

        window.location.replace(location + "?state=" + state + "&sessionId=" + this.transactionId + "&authCode=" + this.authCode);

      })
          .catch(error => {
            /**
             50x internal server error
             400 bad request
             403 forbidden
             410 password expired
             xxx
             */

            const expr = error.response.status;
            console.log("AuthService.qrLogin(user) received status code: " + expr);
            let errorMessage = null;

            switch (expr) {
              case 502: {
                window.location.replace(this.APP_SAML_URL+'/fault?errorCode=2&source=b');
              }
                break;
              case 400: {
                errorMessage = "SPID.RETRY";
                const locationHeader = error.response.headers['location'];
                console.log("attempts terminated response Location:" + locationHeader);

                this.clearData();
                window.location.replace(locationHeader);
              }
                break;
              case 403:
                errorMessage = "SPID.INVALID";
                this.setErrorCode(errorMessage);
                break;
              case 409:
                errorMessage = "SPID.INVALID_AGE";
                this.setErrorAge(error.response.data);
                break;
              case 410: {
                // password expired
                const location = error.response.headers['location'];

                this.clearData();
                console.log("password expired response Location:" + location);
                window.location.replace(location);
              }
                break;
              default: {
                this.clearData();
                window.location.replace(this.APP_SAML_URL+'/fault?errorCode=3&source=b');
              }

            }
          })
          .finally(() => this.loading = false);
    },
    handleWsError(error) {
      let expr;
      if(error.code){
        expr=error.code;
      }else {
        expr=error.errorCode;
      }
      if (this.timeout !== null) {
        clearInterval(this.timeout);
      }

      switch (expr) {

        default: {
          this.errored=true;
        }
      }
    },
    setQrCode() {
      this.wsService.getQrCode().then(qrcode => {
            console.log("QRCODE: ", qrcode );
            if (qrcode) {

              this.qrcode_img = {
                src: qrcode,
                    width: "180",
                    height: "180"
              };
              this.timeout = setInterval(() => {
                    if (this.tempo <= 0) {
                      clearInterval(this.timeout);
                      console.log('Service:', this.wsService);
                      if (this.wsService.service) {
                        console.log("retry");
                        this.wsService.sendNewChallenge(this.transactionId);
                        this.setQrCode();
                      }
                      this.tempo = 30;
                    } else {
                      if (this.wsService.service) {
                        this.tempo--;
                      }

                    }

                  }, 1000

              );
            }
          }
      );
    },
    setErrorCode(errorMessage) {
      console.log(errorMessage);
      this.$emit("error", errorMessage);
      this.errored = true;
    },
    setErrorAge(args) {
      this.ageErrored = args;
    },
    format(msg, args) {
      return msg.replace(/{\w+}/g, function(x) {
        x = x.substring(1, x.length -1);
        return args[x] || x;
      });
    }
  },
};

const _hoisted_1 = { class: "ic1-row-centered" };
const _hoisted_2 = { class: "ic1-col-12 ic1-centered" };
const _hoisted_3 = { class: "ic1-text-label-3" };
const _hoisted_4 = {
  key: 0,
  class: "ic1-col-12 ic1-centered"
};
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
  key: 1,
  class: "ic1-col-12 ic1-centered"
};
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = {
  key: 2,
  class: "ic1-col-12 ic1-text-centered"
};
const _hoisted_9 = { class: "ic1-text-body-2" };
const _hoisted_10 = {
  key: 3,
  class: "ic1-col-12 ic1-centered"
};
const _hoisted_11 = ["src", "width", "height"];
const _hoisted_12 = {
  key: 4,
  class: "ic1-col-12 ic1-centered"
};
const _hoisted_13 = { class: "ic1-text-body-2" };
const _hoisted_14 = ["innerHTML"];
const _hoisted_15 = ["innerHTML"];

function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createElementBlock("div", _hoisted_1, [
    createElementVNode("div", _hoisted_2, [
      createElementVNode("label", _hoisted_3, toDisplayString($data.messages.label_check_myinfocert), 1 /* TEXT */)
    ]),
    ($data.errored)
      ? (openBlock(), createElementBlock("div", _hoisted_4, [
          createElementVNode("span", {
            class: "ic1-text-body-2",
            innerHTML: $data.messages.error
          }, null, 8 /* PROPS */, _hoisted_5)
        ]))
      : createCommentVNode("v-if", true),
    ($data.ageErrored)
      ? (openBlock(), createElementBlock("div", _hoisted_6, [
          createElementVNode("span", {
            class: "ic1-text-body-2",
            innerHTML: $options.format($data.messages.error_age, $data.ageErrored)
          }, null, 8 /* PROPS */, _hoisted_7)
        ]))
      : createCommentVNode("v-if", true),
    (!$data.errored && !$data.ageErrored)
      ? (openBlock(), createElementBlock("div", _hoisted_8, [
          createElementVNode("label", _hoisted_9, toDisplayString($data.messages.qr_code), 1 /* TEXT */)
        ]))
      : createCommentVNode("v-if", true),
    (!$data.errored && !$data.ageErrored)
      ? (openBlock(), createElementBlock("div", _hoisted_10, [
          createElementVNode("img", {
            id: "qrcode",
            src: $data.qrcode_img.src,
            width: $data.qrcode_img.width,
            height: $data.qrcode_img.height,
            alt: "qrcode"
          }, null, 8 /* PROPS */, _hoisted_11)
        ]))
      : createCommentVNode("v-if", true),
    (!$data.errored && !$data.ageErrored)
      ? (openBlock(), createElementBlock("div", _hoisted_12, [
          createElementVNode("label", _hoisted_13, [
            createElementVNode("span", {
              innerHTML: $data.messages.code_valid_for
            }, null, 8 /* PROPS */, _hoisted_14),
            createElementVNode("strong", null, toDisplayString($data.tempo), 1 /* TEXT */),
            createElementVNode("span", {
              innerHTML: $data.messages.seconds
            }, null, 8 /* PROPS */, _hoisted_15)
          ])
        ]))
      : createCommentVNode("v-if", true)
  ]))
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = "\nhr[data-v-d1fd5244] {\n  border: 0.5px solid #C2D1D9;\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n.ic1-card[data-v-d1fd5244] {\n  height: 100%;\n}\n.ic1-col-border-right[data-v-d1fd5244] {\n  border-right: 0.5px solid #C2D1D9;\n}\n.ic1-btn-text-noflex[data-v-d1fd5244] {\n  display: inline;\n}\n.ic1-row-centered[data-v-d1fd5244] {\n  justify-content: center !important;\n  display: inline-block !important;\n  margin: 0 auto !important;\n}\n.ic1-centered[data-v-d1fd5244] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.ic1-text-centered[data-v-d1fd5244] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n.ic1-card-error[data-v-d1fd5244] {\n  /* Auto Layout */\n\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  padding: 0.625rem 1.75rem;\n  position: static;\n  width: fit-content;\n  height: fit-content;\n  left: 0px;\n  top: 0px;\n\n  /* danger-alternative */\n\n  background: #FBE7E7;\n  /* danger */\n\n  border: 1px solid #DA100B;\n  box-sizing: border-box;\n  border-radius: 5px;\n\n  /* Inside Auto Layout */\n\n  flex: none;\n  order: 0;\n  align-self: stretch;\n  flex-grow: 0;\n  margin: 10px 0px;\n}\n";
styleInject(css_248z);

script.render = render;
script.__scopeId = "data-v-d1fd5244";
script.__file = "src/components/QrCode.vue";

var components = { QrCode: script };

const plugin = {
  install (Vue) {
    for (const prop in components) {
      if (components.hasOwnProperty(prop)) {
        const component = components[prop];
        Vue.component(component.name, component);
      }
    }
  }
};

export { plugin as default };
